export default __webpack_public_path__ + "static/media/Staff6.33bd6bc1.jpg";